import helper from './helper'

const getFeedbackUrlWithParameters = helper.getFeedbackUrlWithParameters

export default {
  getFeedbackUrlWithParameters,
  getByRecievedUrlData: (url, gets = null) => getFeedbackUrlWithParameters(
    /**
     * Функция для построения URL из предопределенного объекта URL
     * @param {Object} url - объект конфигурации URL
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    url.basename,
    url.action,
    url.params,
    gets
  ),
  FEEDBACK: {
    CREATE_TICKET:
          (gets = null) => getFeedbackUrlWithParameters(
            /**
             * Создает заявку обратной связи
             * @param {Object} gets - дополнительные query параметры (опционально)
             * @returns {string} URL для создания заявки
             */
            'selfservice|ticket-list',
            'create',
            null,
            gets
          ),
    TICKET_LIST:
          (gets = null) => getFeedbackUrlWithParameters(
            /**
             * Получает список заявок обратной связи
             * @param {Object} gets - дополнительные query параметры (опционально)
             * @returns {string} URL для получения списка заявок
             */
            'selfservice|ticket-list',
            'list',
            null,
            gets
          )
  }
}
